export const tableschema4 = {
    name_table: 'Розділ ІV. Розподіл дітей у групах за мовами виховання на кінець звітного року(Державна статистика)',
    titles:[
      "Усі мови виховання",
      "у тому числі",
      "українська",
      "російська",
      "англійська",
      "болгарська",
      "кримсько-татарська",
      "молдовська",
      "німецька",
      "польська",
      "румунська",
      "словацька",
      "угорська",
      "інша"
    ],
    parts:[
        {title: "Кількість дітей, осіб", subtitle: "", fields:[
          "LNG4000",
          "LNG4010",
          "LNG4020",
          "LNG4030",
          "LNG4040",
          "LNG4050",
          "LNG4060",
          "LNG4070",
          "LNG4080",
          "LNG4090",
          "LNG4100",
          "LNG4110",
          "LNG4120"
        ]}
    ],
    shorts:{
        titles:[
          "4000",
          "4010",
          "4020",
          "4030",
          "4040",
          "4050",
          "4060",
          "4070",
          "4080",
          "4090",
          "4100",
          "4110",
          "4120"
        ],
        parts:[
            "1"
          ]
    }
};